module.exports = __webpack_public_path__ + "img/stock6.833d7069.png";